<div class="page-content">
    <div class="submitted-data default-page-padding" *ngIf="submittedData">
        <p>Thank you!<br>
            The details of POD have been recorded.</p>
    </div>
    <form [formGroup]="tripMaterialForm" *ngIf="!submittedData">
        <p class="trip-details grey-background-line default-page-padding">Trip Details</p>
        <div class="veh-details default-page-padding">
            <p class="veh-data">
                {{tripData?.truckNumber}}&nbsp;&nbsp; | &nbsp;&nbsp;LR No. - 
                {{formType == 'DESTINATION_TYPE' ? tripData?.lorryReceipt?.lorryReceiptNumber : tripData?.dropPoint?.lorryReceipt?.lorryReceiptNumber}}
            </p>
            <p *ngIf="formType == 'DROP_TYPE'" class="od-data">
                <b>{{tripData?.originWarehouseName}}</b> - {{tripData?.dropPoint?.destinationWarehouseName}}, {{tripData?.dropPoint?.destinationCity}}
            </p>
            <p *ngIf="formType == 'DESTINATION_TYPE'" class="od-data">
                <b>{{tripData?.lorryReceipt?.originWarehouseName}}</b> - {{tripData?.warehouseName}}, {{tripData?.city}}
            </p>
        </div>
        <p class="trip-details grey-background-line default-page-padding">Reporting In Date & Time <span class="red">*</span></p>
        <ng-container *ngIf="currentScreen == 'INPUT'; else reviewDateTemplate">
            <div class="date-time-class default-page-padding">
                <mat-form-field appearance="outline" class="width-100 no-padding-left custom-datepicker">
                    <input matInput formControlName="destReportedDate" 
                        [max]="currentDate" (dateChange)="reportedDateEvent('change', $event)" 
                        [matDatepicker]="reportedPicker" placeholder="Choose  Date"
                        required readonly (click)="reportedPicker.open()">
                    <mat-datepicker-toggle matSuffix [for]="reportedPicker">
                        <img matDatepickerToggleIcon class="blue"
                            src="https://console.freightfox.ai/assets/images/calender-icon.svg">
                        <img matDatepickerToggleIcon class="grey"
                            src="https://console.freightfox.ai/assets/images/calendar-grey.svg">
    
                    </mat-datepicker-toggle>
                    <mat-datepicker #reportedPicker></mat-datepicker>
                </mat-form-field>
                <div *ngIf="tripMaterialForm.get('destReportedDate').invalid && tripMaterialForm.get('destReportedDate').touched" class="field-error">
                    Reporting date is required
                </div>
            </div>
                <div #customTip  class="time-picker">
                    <div class="ff_flex">
                        <mat-form-field appearance="outline" class="width-100 ">
                            <input #dateInput (click)="showToolTip = true;"  matInput formControlName="destReportedTime"
                                placeholder="Select Time" readonly required>
                        </mat-form-field>
                        <app-time-picker *ngIf="showToolTip" [restrictFuture]="true" 
                            [dateSelected]="tripMaterialForm.get('destReportedDate').value" 
                            class="custom-time-picker top-margin-neg-45"
                            (onTimePicked)="timePicked($event, 'REPORTED')">
                        </app-time-picker>
                    </div>
                    <div *ngIf="tripMaterialForm.get('destReportedTime').invalid && tripMaterialForm.get('destReportedTime').touched" class="field-error">
                        Reporting time is required
                    </div>
                </div>
        </ng-container>
        <ng-template #reviewDateTemplate>
            <p class="review-p">{{tripMaterialForm.value.destReportedDate | date: 'dd MMM yyyy'}}, {{tripMaterialForm.value.destReportedTime}}</p>
        </ng-template>

        <p class="trip-details grey-background-line default-page-padding">Unloading Date & Time <span class="red">*</span></p>
        <ng-container *ngIf="currentScreen == 'INPUT'; else reviewUnloadingDateTemplate">
            <div class="date-time-class default-page-padding">
                <mat-form-field appearance="outline" class="width-100 no-padding-left custom-datepicker">
                    <input matInput formControlName="unloadingDate" 
                        [max]="currentDate" (dateChange)="unloadedDateEvent('change', $event)" 
                        [matDatepicker]="picker" placeholder="Choose  Date"
                        required readonly (click)="picker.open()">
                    <mat-datepicker-toggle matSuffix [for]="picker">
                        <img matDatepickerToggleIcon class="blue"
                            src="https://console.freightfox.ai/assets/images/calender-icon.svg">
                        <img matDatepickerToggleIcon class="grey"
                            src="https://console.freightfox.ai/assets/images/calendar-grey.svg">
                    </mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
                <div *ngIf="tripMaterialForm.get('unloadingDate').invalid && tripMaterialForm.get('unloadingDate').touched" class="field-error">
                    Unloading date is required
                </div>
            </div>
                <div #customTipUnloadingDiv  class="time-picker">
                    <div class="ff_flex">
                        <mat-form-field appearance="outline" class="width-100 ">
                            <input #dateInput (click)="showToolTipUnloadingTime = true;"  matInput formControlName="unloadingTime"
                                placeholder="Select Time" readonly required>
                        </mat-form-field>
                        <app-time-picker *ngIf="showToolTipUnloadingTime" [restrictFuture]="true" 
                            [dateSelected]="tripMaterialForm.get('unloadingDate').value" 
                            class="custom-time-picker top-margin-neg-45"
                            (onTimePicked)="timePicked($event, 'UNLOADING')">
                        </app-time-picker>
                    </div>
                    <div *ngIf="tripMaterialForm.get('unloadingTime').invalid && tripMaterialForm.get('unloadingTime').touched" class="field-error">
                        Unloading time is required
                    </div>
                </div>
                <div *ngIf="unloadingTimeError" class="time-validation-error">
                    <span class="error-icon">⚠️</span>
                    {{ unloadingTimeError }}
                </div>
        </ng-container>
        <ng-template #reviewUnloadingDateTemplate>
            <p class="review-p">{{tripMaterialForm.value.unloadingDate | date: 'dd MMM yyyy'}}, {{tripMaterialForm.value.unloadingTime}}</p>
        </ng-template>

        <p class="trip-details grey-background-line default-page-padding">Unloading Point Observations</p>

        <div class="unloading-point " formArrayName="materialDispatchInfo">
            <div class="data"
                *ngFor="let material of tripMaterialForm?.get('materialDispatchInfo')?.controls; let i = index;"
                [formGroupName]="i">
                <div class="material-info">
                    <p class="shipping-quantity">{{ material.get('quantity').value }}</p>
                    <p class="shipping-unit">{{ material.get('shippingUnit').value }}</p>,
                    <p class="shipping-unit">{{ material.get('material').value }}</p>
                </div>
                <ng-container *ngIf="currentScreen == 'INPUT'; else reviewShortageTemplate">
                    <div class="dispatch-details ff_flex">
                        <div class="ff_flex shortage-leakage ">
                            <input placeholder="Damage" class="" type="text"
                                inputmode="numeric"
                                pattern="[0-9]*"
                                [ngClass]="material.get('breakageQuantity').errors ?'quanity-error-state':''"
                                formControlName="breakageQuantity"
                                (input)="onNumericInput($event, 'breakageQuantity', i)">
                            <input placeholder="Shortage" class="" type="text"
                                inputmode="numeric"
                                pattern="[0-9]*"
                                [ngClass]="material.get('shortageQuantity').errors ?'quanity-error-state':''"
                                formControlName="shortageQuantity"
                                (input)="onNumericInput($event, 'shortageQuantity', i)">
                        </div>
                    </div>
                </ng-container>
                <ng-template #reviewShortageTemplate>
                    <div class="dispatch-details ff_flex">
                        <div class="ff_flex shortage-leakage ">
                            <p class="review-p">Breakage: {{material.get('breakageQuantity').value}}</p>
                            <p class="review-p">Shortage: {{material.get('shortageQuantity').value}}</p>
                        </div>
                    </div>
                </ng-template>
            </div>

        </div>

        <p class="trip-details grey-background-line default-page-padding">Other Charges & Remarks</p>
        <div class="other-charges">
            <div class="repacking-form-feild">
                <label>Other Charges</label>
                <ng-container *ngIf="currentScreen == 'INPUT'; else reviewOtherChargeTemplate">
                    <input formControlName="repackagingCharges" 
                        placeholder="Enter Repacking Charges"
                        type="text"
                        inputmode="numeric"
                        pattern="[0-9]*"
                        (input)="onNumericInput($event, 'repackagingCharges')">
                    <mat-error
                        *ngIf="tripMaterialForm.get('repackagingCharges').invalid && tripMaterialForm.get('repackagingCharges').touched">
                        Other Charges is invalid
                    </mat-error>
                </ng-container>
                <ng-template #reviewOtherChargeTemplate>
                    <p class="review-p">{{tripMaterialForm.get('repackagingCharges').value | currency: 'INR':'symbol':'1.0-0'}}</p>
                </ng-template>
            </div>
            <div class="repacking-form-feild margin-top-form">
                <label>Remarks</label>
                <ng-container *ngIf="currentScreen == 'INPUT'; else reviRemarksTemplate">
                    <textarea formControlName="remarks" rows="4"></textarea>
                </ng-container>
                <ng-template #reviRemarksTemplate>
                    <p class="review-p">{{tripMaterialForm.get('remarks').value}}</p>
                </ng-template>
            </div>
            <div class="images-div">
                <label>Images ({{tripMaterialForm.value.qcDocs?.length || 0}}/5) <span class="red">*</span></label>
                <ng-container *ngIf="currentScreen == 'INPUT'">
                    <div *ngIf="tripMaterialForm.value.qcDocs.length < 5" class="cp-doc-wrapper ff_topM_5">
                        <div class="attachment-wrapper">
                            <div class="upload-file">
                                <img src="/assets/images/attachment-logo.svg">
                                <label class="label">
                                    <input #multiDocFile 
                                    type="file" 
                                    accept="image/*" 
                                    capture="environment" 
                                    (change)="uploadFile($event)">
                                    Upload Image
                                </label>
                            </div>
                        </div>
                        <p class="file-size-info">Maximum file size: 5 MB</p>
                    </div>
                </ng-container>
            </div>
            
            <!-- Separate section for displaying uploaded images -->
            <div class="uploaded-images-section" *ngIf="tripMaterialForm.value.qcDocs.length > 0">
                <label class="section-label">Uploaded Images</label>
                <div class="images-grid">
                    <div *ngFor="let image of tripMaterialForm.value.qcDocs; let imageIndex = index;" class="image-item">
                        <div class="image-container">
                            <img *ngIf="image.s3Url" [src]="image.s3Url" [alt]="image.documentName" class="uploaded-image" (click)="viewImage(image)">
                            <div *ngIf="!image.s3Url" class="image-placeholder">
                                <span class="placeholder-text">{{image.documentName}}</span>
                            </div>
                            <div class="image-overlay">
                                <button type="button" class="view-btn" (click)="viewImage(image)">
                                    <span class="view-icon">👁</span> View
                                </button>
                             
                                <button type="button" class="delete-btn" (click)="deleteImage(imageIndex)" *ngIf="currentScreen == 'INPUT'">
                                    <span class="delete-icon">🗑</span> Delete
                                </button>
                            </div>
                        </div>
                        <p class="image-name">{{imageIndex + 1}}. {{image.documentName}}</p>
                    </div>
                </div>
            </div>
            
            <div class="videos-div">
                <label>Videos ({{tripMaterialForm.value.videoDocs?.length || 0}}/5)</label>
                <div *ngFor="let video of tripMaterialForm.value.videoDocs; let videoIndex = index;" class="qc-video">
                    <div class="video-item">
                        <div class="video-info">
                            <p class="qc-video-text">{{videoIndex+1}}. {{video.documentName}}</p>
                            <div class="video-actions" *ngIf="currentScreen == 'INPUT'">
                                <button type="button" class="play-btn" (click)="playVideo(video)">
                                    <span class="play-icon">▶</span> Play
                                </button>
                             
                                <button type="button" class="delete-btn" (click)="deleteVideo(videoIndex)">
                                    <span class="delete-icon">🗑</span> Delete
                                </button>
                            </div>
                        </div>
                        <div class="video-preview" *ngIf="video.s3Url">
                            <video 
                                [src]="video.s3Url" 
                                controls 
                                preload="metadata"
                                class="video-player">
                                Your browser does not support the video tag.
                            </video>
                        </div>
                    </div>
                </div>
                <ng-container *ngIf="currentScreen == 'INPUT'">
                    <div *ngIf="tripMaterialForm.value.videoDocs.length < 5" class="cp-doc-wrapper ff_topM_5">
                        <div class="attachment-wrapper">
                            <div class="upload-file">
                                <img src="/assets/images/attachment-logo.svg">
                                <label class="label">
                                    <input #multiVideoFile 
                                    type="file" 
                                    accept="video/*" 
                                    capture="environment" 
                                    (change)="uploadVideo($event)">
                                    Upload Video
                                </label>
                            </div>
                        </div>
                        <p class="video-size-info">Maximum file size: 200 MB</p>
                    </div>
                </ng-container>
            </div>
            <div *ngIf="errorMessage && !isUploadingVideo" class="image-error-message">
                <div class="error-icon">⚠️</div>
                <p class="error-text">{{errorMessage}}</p>
            </div>
            <p *ngIf="isUploadingImage" class="loading-image-info">
                Uploading Image ...
            </p>
            <div *ngIf="isUploadingVideo" class="video-upload-loader">
                <div class="loader-container">
                    <div class="spinner"></div>
                    <p class="loading-text">Uploading Video...</p>
                    <p class="loading-subtext">Please wait while your video is being processed</p>
                    <div class="progress-container">
                        <div class="progress-bar">
                            <div class="progress-fill" [style.width.%]="videoUploadProgress"></div>
                        </div>
                        <p class="progress-text">{{videoUploadProgress | number:'1.0-0'}}%</p>
                    </div>
                </div>
            </div>
            <div *ngIf="errorMessage" class="video-error-message">
                <div class="error-icon">⚠️</div>
                <p class="error-text">{{errorMessage}}</p>
            </div>
            
            <div *ngIf="showVideoSuccess" class="video-success-notification">
                <div class="success-container">
                    <div class="success-icon">✓</div>
                    <p class="success-text">Video uploaded successfully!</p>
                </div>
            </div>
           

            <div class="repacking-form-feild margin-top-form">
                <label>Receiver Details</label>
                <ng-container *ngIf="currentScreen == 'INPUT'; else reviwReceiverTemplate">
                    <input formControlName="reporterDetails" placeholder="Enter Name/Number/Designation ">
                </ng-container>
                <ng-template #reviwReceiverTemplate>
                    <p class="review-p">{{tripMaterialForm.get('reporterDetails').value}}</p>
                </ng-template>
            </div>

            <div class="historic-report-section default-page-padding" *ngIf="!submittedData">
                <button (click)="openHistoricReportModal()" class="historic-report-btn">
                    <span class="btn-icon">📥</span>
                    Download Historic Report
                </button>
            </div>

            <!-- Contact Support Section -->
            <div class="contact-support-section">
                <div class="contact-content">
                    <div class="contact-icon">📞</div>
                    <div class="contact-text">
                        <h4>Facing any issues?</h4>
                        <p>Contact our support team for assistance</p>
                        <p class="business-hours-note" 
                           [class.available]="isWithinBusinessHours"
                           [class.closed]="!isWithinBusinessHours">
                           📅 {{ getBusinessHoursStatus() }}
                        </p>
                    </div>
                    <div class="contact-actions">
                        <a *ngIf="isWithinBusinessHours" 
                           href="tel:+916366344070" 
                           class="contact-btn phone-btn">
                            <div class="phone-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <g clip-path="url(#clip0_1137_4124)">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M16.552 22.133C15.112 22.08 11.031 21.516 6.757 17.243C2.484 12.969 1.921 8.88897 1.867 7.44797C1.787 5.25197 3.469 3.11897 5.412 2.28597C5.64598 2.18494 5.9022 2.14647 6.15553 2.17435C6.40886 2.20222 6.65059 2.29548 6.857 2.44497C8.457 3.61097 9.561 5.37497 10.509 6.76197C10.7176 7.0667 10.8068 7.43752 10.7596 7.80377C10.7123 8.17002 10.532 8.5061 10.253 8.74797L8.302 10.197C8.20774 10.265 8.14139 10.365 8.11528 10.4783C8.08916 10.5916 8.10505 10.7105 8.16 10.813C8.602 11.616 9.388 12.812 10.288 13.712C11.189 14.612 12.441 15.45 13.3 15.942C13.4077 16.0024 13.5345 16.0193 13.6543 15.9892C13.774 15.9591 13.8777 15.8842 13.944 15.78L15.214 13.847C15.4475 13.5368 15.7919 13.329 16.1752 13.2672C16.5584 13.2053 16.9508 13.2941 17.27 13.515C18.677 14.489 20.319 15.574 21.521 17.113C21.6826 17.3209 21.7854 17.5684 21.8187 17.8296C21.8519 18.0908 21.8144 18.3562 21.71 18.598C20.873 20.551 18.755 22.214 16.552 22.133Z" fill="currentColor"></path>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_1137_4124">
                                            <rect width="24" height="24" fill="white"></rect>
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>
                            <div class="phone-number">Call Support</div>
                        </a>
                        <a href="https://wa.me/916366344070" 
                        target="_blank" 
                        class="contact-btn whatsapp-btn"
                        data-button-type="whatsapp">
                            <span class="btn-icon">💬</span>
                            WhatsApp
                        </a>
                    </div>
                </div>
            </div>
        </div>
       
    </form>
    
    <div class="footer  default-page-padding">
        <img src="/assets/images/ff_logo.svg">
        <ng-conatiner *ngIf="currentScreen == 'INPUT'; else previewActionsTemplate">
            <button [disabled]="checkValidity()" (click)="toogleReviewScreens()" class="primary-btn">Review</button>
        </ng-conatiner>
        <ng-template #previewActionsTemplate>
            <div class="final-submit-buttons">
            <button *ngIf="!submittedData" (click)="toogleReviewScreens()" class="primary-btn secondary">Edit</button>
            <button *ngIf="!submittedData" (click)="submitDetails()" class="primary-btn">Submit</button>
        </div>
        </ng-template>
    </div>
</div>



<ng-container *ngIf="showNoChangePopup">
    <div class="no-change">
        <div class="content">
            <p>
                POD cannot be changed after submission.
                Please review before submitting
            </p>
            <button (click)="closeChangePopup()" class="primary-btn">Ok</button>
        </div>
    </div>
</ng-container>

<!-- OTP Verification Modal -->
<ng-container *ngIf="showOTPModal">
    <div class="otp-modal-overlay">
        <div class="otp-modal">
            <div class="otp-modal-header">
                <h3>OTP Verification Required</h3>

                <p class="otp-modal-description" *ngIf="hasTransporterContact">
                    The transporter and driver have been notified. Enter the OTP shared by {{ otpSharedByText }}.
                </p>
                <p class="otp-modal-description" *ngIf="!hasTransporterContact">
                    The driver has been notified. Enter the OTP shared by {{ otpSharedByText }}.
                </p>
                <p class="otp-modal-help" *ngIf="hasTransporterContact">
                    Need help? Contact transporter:
                    <a class="otp-contact-link" [href]="'tel:' + tripData.tspContactMobile">{{ tripData.tspContactMobile }}</a>
                </p>
            </div>
            
            <div class="otp-modal-body">
                <div class="otp-input-group">
                    <label>Enter OTP</label>
                    <div class="otp-boxes-container">
                        <input 
                        type="text" 
                        [(ngModel)]="otpInput" 
                        placeholder="Enter 6-digit OTP"
                        maxlength="6"
                        class="otp-input"
                        (keyup)="onOTPInput($event)">
                    </div>
                </div>
                
                <div *ngIf="otpError" class="otp-error">
                    {{otpError}}
                </div>
                
                <div *ngIf="isOTPVerifying" class="otp-loading">
                    <div class="spinner"></div>
                    <span>Verifying OTP...</span>
                </div>
                
                <!-- Timer and Resend Section -->
                <div class="otp-timer-section">
                    <div class="timer-display" *ngIf="remainingTime && !canResendOTP">
                        <span class="timer-label">Time remaining:</span>
                        <span class="timer-value">{{ remainingTime }}</span>
                    </div>
                    <div class="resend-section" *ngIf="canResendOTP">
                        <button 
                            type="button" 
                            class="btn-resend" 
                            (click)="resendOTP()"
                            [disabled]="resendOtpFlag">
                            {{ resendOtpFlag ? 'Sending...' : 'Resend OTP' }}
                        </button>
                    </div>
                </div>
            </div>
            
            <div class="otp-modal-footer">
                <button 
                    type="button" 
                    class="btn-secondary" 
                    (click)="closeOTPModal()"
                    [disabled]="isOTPVerifying">
                    Cancel
                </button>
                <button 
                    type="button" 
                    class="btn-primary" 
                    (click)="verifyOTP()"
                    [disabled]="!otpInput || otpInput.length !== 6 || isOTPVerifying">
                    Verify & Submit
                </button>
            </div>
        </div>
    </div>
</ng-container>

<!-- Historic Report Download Modal -->
<ng-container *ngIf="showHistoricReportModal">
    <div class="otp-modal-overlay" (click)="closeHistoricReportModal()">
        <div class="otp-modal historic-report-modal" (click)="$event.stopPropagation()">
            <div class="otp-modal-header">
                <h3>Download Historic Report</h3>
                <button type="button" class="close-btn" (click)="closeHistoricReportModal()">×</button>
            </div>
            <div class="otp-modal-body">
                <p class="modal-description">Select a date range to download the historic report. Maximum date range allowed is 92 days.</p>
                
                <div class="date-range-fields" [formGroup]="historicReportForm">
                    <mat-form-field appearance="outline" class="date-field">
                        <mat-label>Start Date</mat-label>
                        <input matInput 
                            formControlName="startDate"
                            [matDatepicker]="startDatePicker" 
                            [max]="currentDate"
                            (dateChange)="onStartDateChange($event)"
                            placeholder="Choose Start Date"
                            readonly
                            (click)="startDatePicker.open()"
                            required>
                        <mat-datepicker-toggle matSuffix [for]="startDatePicker">
                            <img matDatepickerToggleIcon class="blue"
                                src="https://console.freightfox.ai/assets/images/calender-icon.svg">
                            <img matDatepickerToggleIcon class="grey"
                                src="https://console.freightfox.ai/assets/images/calendar-grey.svg">
                        </mat-datepicker-toggle>
                        <mat-datepicker #startDatePicker></mat-datepicker>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="date-field">
                        <mat-label>End Date</mat-label>
                        <input matInput 
                            formControlName="endDate"
                            [matDatepicker]="endDatePicker" 
                            [max]="getMaxEndDate()"
                            [min]="historicReportForm.get('startDate')?.value"
                            (dateChange)="onEndDateChange($event)"
                            placeholder="Choose End Date"
                            readonly
                            (click)="endDatePicker.open()"
                            required>
                        <mat-datepicker-toggle matSuffix [for]="endDatePicker">
                            <img matDatepickerToggleIcon class="blue"
                                src="https://console.freightfox.ai/assets/images/calender-icon.svg">
                            <img matDatepickerToggleIcon class="grey"
                                src="https://console.freightfox.ai/assets/images/calendar-grey.svg">
                        </mat-datepicker-toggle>
                        <mat-datepicker #endDatePicker></mat-datepicker>
                    </mat-form-field>
                </div>

                <div *ngIf="dateRangeError" class="error-message">
                    <span class="error-icon">⚠️</span>
                    {{ dateRangeError }}
                </div>

                <div *ngIf="isDownloadingReport" class="download-progress">
                    <div class="progress-spinner"></div>
                    <p class="progress-text">{{ downloadProgress }}</p>
                </div>
            </div>
            
            <div class="otp-modal-footer">
                <button 
                    type="button" 
                    class="btn-secondary" 
                    (click)="closeHistoricReportModal()"
                    [disabled]="isDownloadingReport">
                    Cancel
                </button>
                <button 
                    type="button" 
                    class="btn-primary" 
                    (click)="downloadHistoricReport()"
                    [disabled]="isDownloadingReport">
                    <span *ngIf="!isDownloadingReport">Download Report</span>
                    <span *ngIf="isDownloadingReport">Downloading...</span>
                </button>
            </div>
        </div>
    </div>
</ng-container>